
import { useMemo, useReducer } from 'react';
import { getItem, setItem } from '../../shared/storage';

const ACTIONS = {
  updatePlanDetail: 'UPDATE_PLAN_DETAIL'
};

const INITIAL_STATE = { 
  code: 'd4f96b88-c0a6-11ea-aabd-0242ac110003',
  name: 'Especial',
  value: 'R$ 29,99',
  isPj: false,
  hasOrthodontics: false,
  complete: false,
  numberOfLives: 1,
}

const reducer = (state, { type, payload }) => {
  switch (type) {
    case ACTIONS.updatePlanDetail:
      setItem('selectedPlan', payload)
      return {
        ...state,
        ...payload
      };
    default:
      return state;
  }
}

const usePlan = () => {
  const [state, dispatch] = useReducer(reducer, getItem('selectedPlan') || INITIAL_STATE);

  const actions = useMemo(() => ({
    updatePlanDetail: (payload = {}) => dispatch({ type: ACTIONS.updatePlanDetail, payload })
  }))
  return [
    state,
    actions
  ]
}

export default usePlan;